import { useState, useCallback, useEffect } from 'react'
import { getLiveSockets, disconnectSocket } from 'api/live'
import { safeParseDate } from 'utils/date'
import { useMessageSnackbarActions } from 'elements/MessageContext/MessageContext'

export const useSocketData = () => {
  const [sockets, setSockets] = useState([])
  const [loading, setLoading] = useState(false)
  const { setErrorMessage, setSuccessMessage } = useMessageSnackbarActions()

  const fetchData = useCallback(async () => {
    setLoading(true)

    try {
      const data = await getLiveSockets()
      setSockets(data)
    } catch (err) {
      console.error('Error fetching socket data:', err)
      setErrorMessage('Error al cargar los datos de conexión')
    } finally {
      setLoading(false)
    }
  }, [setErrorMessage])

  const handleDisconnect = useCallback(
    async socket => {
      try {
        await disconnectSocket({ socketId: socket._id })
        setSuccessMessage(`${socket.name} desconectado correctamente`)
      } catch (err) {
        console.error('Error disconnecting socket:', err)
        setErrorMessage(`Error al desconectar a ${socket.name}: ${err.message}`)
      } finally {
        fetchData()
      }
    },
    [fetchData, setErrorMessage, setSuccessMessage]
  )

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    sockets,
    loading,
    refetch: fetchData,
    disconnect: handleDisconnect
  }
}
